import http from '../http'

const api = {
    // 获取页面配置
    getPageInfo(params) {
        return http.get('/wp-json/dt_api/story', {
            params,
        })
    },
}

const state = {
    banners: [],
    story: {
        abstract: {

        },
        detail: []
    },
    pastStories: [],
}

const mutations = {
    GET_BANNERS: state => {
        return state
    },
    SET_BANNERS: (state, {banners}) => {
        state.banners = banners
    },
    SET_PAGE_TITLE: (state, {pageTitle}) => {
        state.pageTitle = pageTitle
    },
    SET_STORY: (state, {story}) => {
        state.story = story
    },
    SET_PAST_STORIES: (state, {pastStories}) => {
        state.pastStories = pastStories
    },
}

// 所有的mutations转换成actions进行调用
const actions = {
    async getPageInfo({commit}, slug) {
        commit('GET_BANNERS')
        const lang = window.localStorage.getItem('lang')

        await api.getPageInfo({
            slug: slug,
            lang,
        }).then(res => {
            if (res.data.data) {
                commit('SET_BANNERS', {
                    banners: res.data.data.banner_pictures,
                })

                commit('SET_PAGE_TITLE', {
                    pageTitle: res.data.data.title,
                })

                commit('SET_STORY', {
                    story:{
                        abstract: {
                            title: res.data.data.title,
                            desc: res.data.data.excerpt
                        },
                        detail: res.data.data.content || []
                    },
                })

                commit('SET_PAST_STORIES', {
                    pastStories: res.data.data.past_stories,
                })

                commit('common/SET_PAGE_THEME',  {
                    theme: res.data.data.theme
                }, {root: true})
                commit('common/SET_THEME',  {
                    theme: res.data.data.theme,
                    wxShare: res.data.data.wechat_share,
                }, {root: true})
            }
        })
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
